<template>
  <div class="bg-gray p-2 border-main-container">
    <div class="bg-white p-3 rounded pl-c-xl">
      <div class="mr-4 ml-4">
        <icon-view
          class="mr-2 mt-1 rounded-circle icon-view-color-text"
          icon="fas fa-edit"
          icon-background="white"
          icon-color="#2DB782"
          icon-size="16px"
          :title="title"
        />
        <validation-observer ref="adressInfoForm" v-slot="{}" tag="form">
          <div class="row mt-4">
            <div class="col-md-4 mb-3">
              <span class="data-title d-block mb-2">Dirección (Línea 1):</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomAddressOne"
                rules="required"
              >
                <input
                  v-if="copyAddress"
                  id="customAddressLine1Disabled"
                  type="text"
                  class="form-control"
                  disabled
                  :value="model.address1"
                />
                <CustomInput
                  v-else
                  id="CustomInputAddressOne"
                  v-model="model.address1"
                  :error="errors[0]"
                  custom-error-msg="La dirección (línea 1) es requerida."
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block mb-2">Dirección (Línea 2):</span>
              <input
                v-if="copyAddress"
                id="CustomInputAddressTwoDisabled"
                type="text"
                class="form-control"
                disabled
                :value="model.address2"
              />
              <CustomInput
                v-else
                id="CustomInputAddressTwo"
                v-model="model.address2"
              />
            </div>
            <div class="col-md-4">
              <span class="data-title d-block mb-2">Municipio:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomMunicipes"
                rules="required"
              >
                <input
                  v-if="copyAddress"
                  id="customDropDownMunicipatiesDisabled"
                  type="text"
                  class="form-control"
                  disabled
                  :value="municipalityName"
                />
                <CustomDropDown
                  v-else
                  id="customDropDownMunicipaties"
                  :error="errors[0]"
                  custom-error-msg="El municipio es requerido."
                  v-model="model.municipality"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  :options="municipalities"
                  :disabled="copyAddress"
                />
              </validation-provider>
            </div>
            <div class="col-md-4 mb-3">
              <span class="data-title d-block mb-2">Código Postal:</span>
              <validation-provider
                v-slot="{ errors }"
                name="validationCustomPostal"
                rules="required|min:5|max:10"
                :custom-messages="{
                  min: 'El código postal no es válido.',
                  max: 'El código postal no es válido.',
                  required: 'El código postal es requerido.'
                }"
              >
                <input
                  v-if="copyAddress"
                  id="customPostalEmailDisabled"
                  type="text"
                  class="form-control"
                  disabled
                  :value="model.zipCode"
                />
                <CustomInput
                  v-else
                  id="CustomInputPostal"
                  mask-type="PostalCode"
                  :error="errors[0]"
                  :custom-error-msg="errors[0]"
                  placeholder="xxxxx-xxxx"
                  v-model="model.zipCode"
                />
              </validation-provider>
            </div>
            <div class="col-md-4 text-right pt-4 align-self-center">
              <CheckBox
                v-if="isPostal"
                id="address-info-check"
                v-model="copyAddress"
                class="font-weight-bold"
                text="La misma dirección que la física"
                @input="$emit('check-same-address-than-physical', $event)"
              />
            </div>
          </div>
        </validation-observer>
        <div class="row my-2">
          <div class="col-md-4 offset-md-8 text-right">
            <ActionButton
              id="address-info-cancel"
              i="fas fa-times-circle"
              variant="outline-danger mx-1"
              text="Cancelar"
              @click="cancel()"
            />
            <ActionButton
              id="address-info-save"
              i="fas fa-save"
              variant="success mx-1"
              text="Guardar"
              @click="save()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import CustomInput from "@/components/common/CustomInput";
import CustomDropDown from "@/components/common/CustomDropDown";
import ActionButton from "@/components/common/ActionButton";
import CheckBox from "CheckBox";

export default {
  name: "AddressInformation",
  components: {
    IconView,
    CustomInput,
    CustomDropDown,
    ActionButton,
    CheckBox
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {
        return {
          address1: null,
          address2: null,
          municipality: null,
          zipCode: null
        };
      }
    },
    municipalities: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "Editar Dirección"
    },
    isPostal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value,
      copyAddress: false
    };
  },
  computed: {
    municipalityName() {
      return this.model.municipality?.name;
    }
  },
  watch: {
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    async validate() {
      await this.$refs.adressInfoForm.validate();
    },
    async save() {
      const isValid = await this.$refs.adressInfoForm.validate();
      if (isValid) {
        this.$emit("save", this.model);
      } else {
        this.$emit("invalid-address", this.model);
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped></style>
